export const SET_REFERRAL_CAMPAIGNS = 'PRO/SET_REFERRAL_CAMPAIGNS'
export type SET_REFERRAL_CAMPAIGNS = typeof SET_REFERRAL_CAMPAIGNS
